export const prefix = 'MAIN_APP::';
export const domain = 'MainApp';